<section class="centered-with-padding py-7">
  <div class="desk:max-w-[70%]" [class.desk:mx-auto]="data.alignment === 'center'">
    <app-title-description [titleDescription]="data"></app-title-description>
  </div>
</section>
